import React, { useState, useContext, createContext, useEffect } from "react";

import PropTypes from "prop-types";

const GetDataImsContext = createContext();

export function GetDataImsProvider({ children }) {
  const [dataCampaign, setDataCampaign] = useState([]);
  const [dataParameters, setDataParameters] = useState([]);
  const [dataPending, setDataPending] = useState([]);
  const [searching, setSearching] = useState(false);

  async function getdataCampaign(month, year) {
    setSearching(true);
    const response = await fetch(
      `${
        process.env.REACT_APP_LINK_API
      }/params?campanha=formula_2024&ano=${year}&mes=${month + 1}`
    );
    const { data } = await response.json();
    setDataCampaign(data[0].details);
    setSearching(false);
  }

  async function getDataParameters() {
    if (dataCampaign.length > 0) {
      const response = await fetch(
        `${process.env.REACT_APP_LINK_API}/${dataCampaign[0].name_params}?ano=${dataCampaign[0].nr_ano}&mes=${dataCampaign[0].nr_mes}&campanha=${dataCampaign[0]?.campanha}`
      );
      const responseData = await response.json();
      if (!responseData.data) {
      }

      setDataParameters(responseData[0].data[0].details);
    }
  }

  async function getDataLogs(mes, ano) {
    if (mes && ano) {
      const response = await fetch(
        `${process.env.REACT_APP_LINK_API}/logs?campanha=formula_2024&status=pendente&mes=${mes}&ano=${ano}`
      );
      const responseData = await response.json();

      if (!responseData.data) {
        setDataPending([]);
        return [];
      }

      const { data } = responseData;

      setDataPending(data);
    } else {
      const response = await fetch(
        `${process.env.REACT_APP_LINK_API}/logs?campanha=formula_2024&status=pendente`
      );

      const responseData = await response.json();

      if (!responseData.data) {
        setDataPending([]);
        return [];
      }

      const { data } = responseData;

      setDataPending(data);
    }
  }

  useEffect(() => {
    getDataParameters();
  }, [dataCampaign]);

  return (
    <GetDataImsContext.Provider
      value={{
        getdataCampaign,
        dataCampaign,
        dataParameters,
        searching,
        dataPending,
        getDataLogs,
      }}
    >
      {children}
    </GetDataImsContext.Provider>
  );
}

export function UseGetDataIms() {
  const context = useContext(GetDataImsContext);

  return context;
}

GetDataImsProvider.defaultProps = {
  children: PropTypes.elementType,
};

UseGetDataIms.defaultProps = {
  getdataCampaign: PropTypes.func,
  dataCampaign: PropTypes.array,
  dataParameters: PropTypes.array,
  searching: PropTypes.bool,
};
